import React, { useEffect, useState } from "react";
import { API_ENDPOINT, API_URL_2 } from "../../api/constant";
import { callApi } from "../../api/callApi";
import Layout from "../../components/Layout/Layout";
import useConfirmationModal from "../../hooks/useConfirmationModal";
import ConfirmationModal from "../../components/UI/Modal/ConfirmationModal";
import Table from "../../components/UI/CommonTable/CommonTable";
import { SeoFormData } from "../../interfaces/seo";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
const SEOListing: React.FC = () => {
    const [seoList, setSeoList] = useState<SeoFormData[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const { showModal, modalProps, confirmAction } = useConfirmationModal();
    const navigate = useNavigate();

    useEffect(() => {
        getSeoDatas();
    }, []);

    const getSeoDatas = async () => {
        try {
            setLoading(true);
            const response = await callApi(API_URL_2 + API_ENDPOINT.page + 'seo?entityType=page', { method: 'GET' });
            setSeoList(response.data);
        } catch (error: any) {
            console.error('Failed to fetch seoList:', error.message);
        } finally {
            setLoading(false);
        }
    };

    const deleteSeoData = async (id: string) => {
        try {
            await callApi(API_URL_2 + API_ENDPOINT.page + `seo/${id}`, { method: 'DELETE' });
            setSeoList((prevSeoDatas: SeoFormData[]) => prevSeoDatas.filter((seo) => seo.id !== id));
        } catch (error: any) {
            console.error('Failed to delete seo:', error.message);
        }
    };

    const handleEditSeoData = (seo: SeoFormData) => {
        navigate(`/edit-seo/${seo.id}`);
    };

    const handleDeleteClick = (id: string) => {
        confirmAction({
            title: 'Confirm Delete',
            message: 'Are you sure you want to delete this seo?',
            onConfirm: () => deleteSeoData(id),
        });
    };

    const columns = [
        { header: "Page", accessor: "pagePath" },
        { header: "Meta Title", accessor: "metaTitle" },
        { header: "Meta Description", accessor: "metaDescription" },
        { header: "Meta Keywords", accessor: "metaKeywords" },
        { header: "OG Title", accessor: "ogTitle" },
        { header: "OG Description", accessor: "ogDescription" },
    ];

    const actions = [
        {
            icon: "bi bi-pen",
            color: "success",
            onClick: (seo: SeoFormData) => handleEditSeoData(seo),
        },
        {
            icon: "bi bi-trash3",
            color: "danger",
            onClick: (seo: SeoFormData) => handleDeleteClick(seo?.id || ""),
        },
    ];

    return (
        <Layout>
            <div className='d-flex justify-content-between align-items-start'>
                <h1 className="app-page-title">SEO List</h1>
                <div className='d-flex gap-2'>
                    <Link to={"/add-seo"} className='btn app-btn-primary d-flex align-items-center gap-1'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M6 0C6.13261 0 6.25979 0.0526785 6.35355 0.146447C6.44732 0.240215 6.5 0.367392 6.5 0.5V5.5H11.5C11.6326 5.5 11.7598 5.55268 11.8536 5.64645C11.9473 5.74021 12 5.86739 12 6C12 6.13261 11.9473 6.25979 11.8536 6.35355C11.7598 6.44732 11.6326 6.5 11.5 6.5H6.5V11.5C6.5 11.6326 6.44732 11.7598 6.35355 11.8536C6.25979 11.9473 6.13261 12 6 12C5.86739 12 5.74021 11.9473 5.64645 11.8536C5.55268 11.7598 5.5 11.6326 5.5 11.5V6.5H0.5C0.367392 6.5 0.240215 6.44732 0.146447 6.35355C0.0526785 6.25979 0 6.13261 0 6C0 5.86739 0.0526785 5.74021 0.146447 5.64645C0.240215 5.55268 0.367392 5.5 0.5 5.5H5.5V0.5C5.5 0.367392 5.55268 0.240215 5.64645 0.146447C5.74021 0.0526785 5.86739 0 6 0Z" fill="white" />
                        </svg> Add SEO
                    </Link>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <div className="app-card app-card-orders-table shadow-sm mb-4 p-4">
                        <div className="app-card-body">
                            <Table
                                columns={columns}
                                data={seoList}
                                loading={loading}
                                actions={actions}
                                emptyMessage="No products available."
                            />
                        </div>
                    </div>
                </div>


            </div>
            <ConfirmationModal {...modalProps} show={showModal} />
        </Layout>
    );
};

export default SEOListing;
